import React, { useState, useEffect } from 'react';
import { MessageCircle, Phone, X } from 'lucide-react';
import { companyInfo } from '../data/mock';

const PROJECT_GREEN = '#1E4D2B';
const WHATSAPP_GREEN = '#25D366';
const ANIM_DURATION = 300;

const BeratungButton = () => {
  const [expanded, setExpanded] = useState(false);
  const [entered, setEntered] = useState(false);
  const [closing, setClosing] = useState(false);

  const phoneRaw = companyInfo.phone.replace(/\s/g, '');
  const phoneTel = phoneRaw.startsWith('0') ? phoneRaw : `0${phoneRaw}`;
  const whatsappNumber = phoneRaw.startsWith('0') ? `49${phoneRaw.slice(1)}` : phoneRaw;

  useEffect(() => {
    if (expanded && !closing) {
      setEntered(false);
      const t = setTimeout(() => setEntered(true), 30);
      return () => clearTimeout(t);
    }
    if (!expanded) setEntered(false);
  }, [expanded, closing]);

  const handleToggle = () => {
    if (expanded) {
      setClosing(true);
      setTimeout(() => {
        setExpanded(false);
        setClosing(false);
      }, ANIM_DURATION);
    } else {
      setExpanded(true);
    }
  };

  const showMenu = expanded || closing;
  const menuVisible = entered && !closing;

  return (
    <div className="fixed right-4 bottom-4 z-30 flex flex-col items-end gap-2">
      {showMenu && (
        <div
          className={`flex flex-col gap-2 transition-all duration-300 ease-out ${
            menuVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'
          }`}
        >
          <a
            href={`tel:${phoneTel}`}
            className="flex items-center justify-center gap-2.5 px-5 py-3.5 rounded-full font-semibold text-white text-base shadow-lg hover:opacity-90 transition-opacity min-h-[48px] whitespace-nowrap"
            style={{ backgroundColor: PROJECT_GREEN }}
          >
            <Phone className="w-6 h-6 shrink-0" />
            Anrufen
          </a>
          <a
            href={`https://wa.me/${whatsappNumber}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2.5 px-5 py-3.5 rounded-full font-semibold text-white text-base shadow-lg hover:opacity-90 transition-opacity min-h-[48px] whitespace-nowrap"
            style={{ backgroundColor: WHATSAPP_GREEN }}
          >
            <MessageCircle className="w-6 h-6 shrink-0" />
            WhatsApp
          </a>
        </div>
      )}

      <button
        type="button"
        onClick={handleToggle}
        className="flex items-center justify-center gap-2.5 px-5 py-3.5 rounded-full font-semibold text-white text-base shadow-lg transition-opacity min-h-[48px] whitespace-nowrap hover:opacity-90"
        style={{ backgroundColor: PROJECT_GREEN }}
        aria-label={expanded ? 'Schließen' : 'Beratung starten'}
      >
        {expanded ? (
          <>
            <X className="w-6 h-6 shrink-0" />
            Schließen
          </>
        ) : (
          <>
            <MessageCircle className="w-6 h-6 shrink-0" />
            Beratung starten
          </>
        )}
      </button>
    </div>
  );
};

export default BeratungButton;
